import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Product, CartContextType } from '../interfaces';

// Define context
export const CartContext = createContext<CartContextType | null>(null);

// Cart Provider
export const CartProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [cart, setCart] = useState<Product[]>([]);

  // Function to add products to the cart
  const addToCart = (product: Product) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.id === product.id);
      if (existingProduct) {
        return prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
  };

  // Function to remove a product from the cart
  const removeFromCart = (id: number) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  };

// Function to empty the cart
  const clearCart = () => {
    setCart([]);
  };

  // Function ti update the quantity of a product in the cart
  const updateQuantity = (id: number, quantity: number) => {
    console.log(cart, 'cart en cartContext.tsx')
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === id ? { ...item, quantity } : item
      )
    );
  };

  // Function to increase the quantity of a product in the cart by 1
  const increaseQuantity = (id: number) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === id ? { ...item, quantity: Math.min(item.quantity + 1, 20) } : item
      )
    );
  };

  // Function to decrease the quantity of a product in the cart by 1
  const decreaseQuantity = (id: number) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === id ? { ...item, quantity: Math.max(item.quantity - 1, 0) } : item
      )
    );
  };

  return (
    <CartContext.Provider
    value={{
      cart,
      addToCart,
      removeFromCart,
      clearCart,
      updateQuantity,
      increaseQuantity,
      decreaseQuantity,
    }}
  >      {children}
    </CartContext.Provider>
  );
};

// Hook to use the cart context
export const useCart = () => {
  return useContext(CartContext);
};
